// Controls
import { ThemeProvider } from "@fluentui/react";
// Utilities
import React from "react";
/**
 * Provider component that conditionally wraps children with v8 ThemeProvider.
 * Used for legacy components that still require Fluent UI v8 theming.
 * @param props Component props including v8 theme configuration
 */ export const LegacyThemeProvider = ({ v8Theme, children })=>{
    // Only wrap with v8 ThemeProvider if theme is available
    if (v8Theme) {
        return /*#__PURE__*/ React.createElement(ThemeProvider, {
            theme: v8Theme
        }, children);
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
};
